// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Title-module--bx--text-truncate--end--12sJy","bxTextTruncateFront":"Title-module--bx--text-truncate--front--2doFM","title":"Title-module--title--3nRQN"};